import type { ReactNode } from 'react';

import { useMemo } from 'react';

import type { ScreenSizeContextState } from '../hooks/use-screen-size';

import { SCREEN_SIZES } from '../config/screen-sizes';
import { useMediaQuery } from '../hooks/use-media-query';
import {
    ScreenSizeContext,

} from '../hooks/use-screen-size';

type ScreenSizeProviderProps = {
    children: ReactNode;
};

export function ScreenSizeProvider(props: ScreenSizeProviderProps) {
    const isMobile = useMediaQuery(
        `(min-width: ${SCREEN_SIZES.mobile.minWidth}px) and (max-width: ${SCREEN_SIZES.mobile.maxWidth}px)`,
    );
    const isTablet = useMediaQuery(
        `(min-width: ${SCREEN_SIZES.tablet.minWidth}px) and (max-width: ${SCREEN_SIZES.tablet.maxWidth}px)`,
    );
    const isDesktop = useMediaQuery(
        `(min-width: ${SCREEN_SIZES.desktop.minWidth}px)`,
    );

    const value = useMemo<ScreenSizeContextState>(
        () => ({
            size: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
            isMobile,
            isTablet,
            isDesktop,
        }),
        [isMobile, isTablet, isDesktop],
    );

    return (
        <ScreenSizeContext value={value}>
            {props.children}
        </ScreenSizeContext>
    );
}
